import { useState } from "react";
import { useEntity, EditDialog, Field } from "./components/crud";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Pencil, Plus, Trash2 } from "lucide-react";

const BLANK = { name: "", color: "#0d0c0c", is_default: false, is_system: false, sort: 0 };

export default function StatusesPage() {
  const { items, save, remove } = useEntity("statuses");
  const [draft, setDraft] = useState(null);
  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v }));

  return (
    <div data-testid="admin-statuses-page">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">Booking statuses</h1>
        <Button data-testid="add-status-btn" onClick={() => setDraft({ ...BLANK, sort: items.length + 1 })}>
          <Plus size={16} className="mr-1" /> Add status
        </Button>
      </div>
      <div className="bg-white border rounded-lg divide-y">
        {items.map((s) => (
          <div key={s.id} className="flex items-center gap-4 px-4 py-3">
            <span className="w-4 h-4 rounded shrink-0 border" style={{ background: s.color }} />
            <p className="flex-1 font-medium text-sm">{s.name}</p>
            {s.is_default && <span className="text-xs px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700">Default</span>}
            {s.is_system && <span className="text-xs px-2 py-0.5 rounded-full bg-stone-200 text-stone-600">System</span>}
            <Button variant="ghost" size="icon" data-testid={`edit-status-${s.id}`} onClick={() => setDraft(s)}><Pencil size={14} /></Button>
            {!s.is_system && (
              <Button variant="ghost" size="icon" data-testid={`delete-status-${s.id}`} onClick={() => window.confirm(`Delete "${s.name}"?`) && remove(s.id)}><Trash2 size={14} /></Button>
            )}
          </div>
        ))}
      </div>

      {draft && (
        <EditDialog open title={draft.id ? "Edit status" : "New status"} onClose={() => setDraft(null)}
          onSave={async () => (await save(draft)) && setDraft(null)}>
          <Field label="Name"><Input data-testid="status-name-input" value={draft.name} onChange={(e) => set("name", e.target.value)} /></Field>
          <div className="grid grid-cols-2 gap-4">
            <Field label="Colour"><input type="color" value={draft.color} className="h-9 w-full border rounded" onChange={(e) => set("color", e.target.value)} /></Field>
            <Field label="Sort"><Input type="number" value={draft.sort} onChange={(e) => set("sort", Number(e.target.value))} /></Field>
          </div>
        </EditDialog>
      )}
    </div>
  );
}
